import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { HomeIcon } from "@heroicons/react/24/outline";

const UnderConstruction = () => (
  <div className="min-h-screen bg-slate-50 dark:bg-[#0B1120] flex flex-col items-center justify-center px-6">
    <motion.div
      className="w-full max-w-xl text-center"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 dark:border-primary-800 bg-primary-50 dark:bg-primary-900/30 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-primary-700 dark:text-primary-300">
        <span className="h-1.5 w-1.5 rounded-full bg-primary-500 animate-pulse" />
        In Development
      </span>

      <h1 className="mt-6 text-4xl font-bold tracking-tight text-slate-900 dark:text-white sm:text-5xl">
        Something great is
        <br />
        <span className="bg-gradient-to-r from-primary-600 to-primary-400 bg-clip-text text-transparent">
          on its way
        </span>
      </h1>

      <p className="mt-5 text-base leading-7 text-slate-500 dark:text-slate-400">
        This page is currently being built by our team. Check back soon.
      </p>

      <Link
        to="/central-dashboard"
        title="Go to Dashboard"
        className="mt-8 inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium text-slate-600 dark:text-slate-400 border border-slate-200 dark:border-slate-700 hover:bg-slate-100 dark:hover:bg-slate-800 transition"
      >
        <HomeIcon className="h-4 w-4" />
        <span>Dashboard</span>
      </Link>
    </motion.div>
  </div>
);

export default UnderConstruction;
